/* eslint-disable no-nested-ternary */
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { space, color } from 'styled-system';
import colors from 'theme/charts/colors';
import translations from 'translations';

const Label = styled.div`
  ${color}
  ${space}

  display: flex;
  flex-direction: row;
  width: fit-content;
  border-radius: 4px;
`;

function OrderTypeCard({ type: typeProp, style }) {
  const { languageCode } = useSelector((state) => state.config);
  const type = typeProp?.toLowerCase();
  return (
    <Label
      mt="xs"
      px="xs"
      py="xxs"
      color="white"
      bg={
        type === 'rent'
          ? colors.business_revenues[2]
          : type === 'buy'
          ? colors.business_revenues[0]
          : type === 'refund'
          ? colors.business_revenues[0]
          : type === 'lending'
          ? colors.business_revenues[4]
          : type === 'free_download'
          ? colors.business_revenues[4]
          : type === 'repartition_charge'
          ? colors.business_revenues[5]
          : type === 'coupon'
          ? colors.business_revenues[3]
          : colors.business_revenues[1]
      }
      {...style}
    >
      {type === 'rent'
        ? translations[languageCode].libraries
        : type === 'buy'
        ? 'Retail'
        : type === 'refund'
        ? translations[languageCode].refund
        : type === 'lending'
        ? 'Lending'
        : type === 'free_download'
        ? translations[languageCode].free_download
        : type === 'subscription'
        ? translations[languageCode].subscription
        : type === 'repartition_charge'
        ? translations[languageCode]['sales breakdown']
        : type === 'coupon'
        ? 'Coupon'
        : 'Not defined'}
    </Label>
  );
}

export default OrderTypeCard;
